import type { HTMLAttributes, ReactNode } from 'react'

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  /** Border radius preset. Default 24px. */
  radius?: 'md' | 'lg' | 'xl' | '2xl'
  children?: ReactNode
}

const RADIUS: Record<NonNullable<GlassCardProps['radius']>, string> = {
  md:  'rounded-2xl',   // 16px
  lg:  'rounded-[20px]',
  xl:  'rounded-3xl',   // 24px — default
  '2xl': 'rounded-[28px]',
}

/**
 * Liquid Glass card — the canonical chrome-layer surface. Never use for
 * dense data (tables, editors). See DESIGN.md §14.
 *
 * All five glass ingredients live in .liquid-glass (index.css):
 *   translucent body · backdrop-blur saturate · specular inset ·
 *   1px glass edge · cast shadow.
 */
export function GlassCard({ radius = 'xl', className = '', children, ...rest }: GlassCardProps) {
  return (
    <div className={`liquid-glass ${RADIUS[radius]} ${className}`} {...rest}>
      {children}
    </div>
  )
}
